<div>
  <div
    class="wholeContainer"
  >
    <div
    >
      <img src="{{playerPhoto || '/static/img/avatar/1.jpg'}}"  alt="Player photo">
    </div>
    <div
      class="playerSummaryStyle"
    >
      <div *ngIf="getPlayerCountry()">
        <span
        *ngIf="getPlayerCountryCode()"
        class="fi fi-{{getPlayerCountryCode()}}"
        >
        </span>

        {{getPlayerCountry()}}
      </div>
      <div *ngIf="getPlayerCity()">{{getPlayerCity()}}</div>
      <div *ngIf="getPlayerTitle()">{{getPlayerTitle()}}</div>
      <div><b>Возраст: </b>{{getPlayerAge()}}</div>
      <div><b>Дата рождения: </b>{{getPlayerBirthdate()}}</div>
      <div><b>Кий: </b>{{getPlayerCue()}}</div>
      <div><b>Турниров: </b>{{getPlayerCountTournaments()}}</div>
      <div><b>Игр: </b>{{getPlayerCountDuelSeries()}} (побед: {{getPlayerCountWinnerDuelSeries()}}, поражений: {{getPlayerCountLooserDuelSeries()}})</div>
      <div (click)="playerVideoClickHandler()">
        <b>Видео: </b> <span [ngClass]="{'videoStyle' : hasVideo()}">{{ getVideoCount() }}</span>
      </div>
      <div (click)="playerTrainerClickHandler()">
        <b>Тренер: </b> <div class="trainerStyle" [ngClass]="{'trainerNameStyle' : getTrainerId()}">{{getPlayerTrainer()}}
      </div>
    </div>
  </div>
</div>
